import { styled } from '@mui/material/styles';
import { FormControl, InputBase, Paper, Select } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  margin: theme.spacing(1),
}));

export const SearchPaper = styled(Paper)({
  // Match prod (v5) appearance: a plain Paper with default elevation. The
  // explicit border added in PFM-2599 QA round 1 read as a heavier outline /
  // dark line vs. prod (Sam, round 2). Remove and rely on Paper's shadow.
  position: 'relative',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
});

export const SearchIconWrap = styled('div', {
  shouldForwardProp: (prop) => prop !== 'sidebar',
})(({ theme, sidebar }) => ({
  width: sidebar ? theme.spacing(5) : theme.spacing(9),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: sidebar ? undefined : 'grey',
}));

export const SearchInput = styled(InputBase, {
  shouldForwardProp: (prop) => !['sidebar', 'noPaddingLeft'].includes(prop),
})(({ theme, sidebar, noPaddingLeft }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    paddingTop: sidebar ? theme.spacing(1) : theme.spacing(2),
    paddingRight: theme.spacing(1),
    paddingBottom: sidebar ? theme.spacing(1) : theme.spacing(2),
    paddingLeft: noPaddingLeft ? 0 : theme.spacing(6),
    transition: theme.transitions.create('width'),
    width: '100%',
  },
}));

export const ClearIconBtn = styled('div')({
  width: '2em',
  height: '2em',
});

export const SortContainer = styled(Paper)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  padding: theme.spacing(1),
  height: 36,
}));

export const SortForm = styled(FormControl)({
  marginTop: -4,
});

export const SortSelectStyled = styled(Select)({
  width: 150,
});
